import { useEffect, useState } from 'react';
import AddBtn from '../../components/common/AddBtn';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import {
  LINK_URL,
  PAGE_SINGLE_TITLE,
  PAGE_TITLE,
  SIDEBAR_OPTIONS,
  inputFields,
} from '../../shared/enums/activitys_enum';
import {
  useAllActivitys,
  useGetDropdownOptions,
  useUpdateActivity,
} from '../../shared/hooks/UseActivity';

import {
  useAllComments,
  useCreateComment,
} from '../../shared/hooks/UseComment';

import { Form, Formik } from 'formik';
import moment from 'moment';
import ReactModal from 'react-modal';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { ChecklistModal } from '../../components/activity/ChecklistModal';
import ExportComponent from '../../components/common/ExportComponent';
import FilterDateComponent from '../../components/common/FilterDateComponent';
import QuickAddBtn from '../../components/common/QuickAddBtn';
import SingleView from '../../components/common/SingleView';
import { TextArea } from '../../components/Form/Form';
import { LIMIT } from '../../domain/constant';
import { useActivities } from '../../hooks/useActivity';
import { UseDataForExcel, UseFilter } from '../../shared/hooks/UseExcel';
import EnhancedTableSection from './_components/Table-View';
import { useSearchParams } from 'react-router-dom';

const AllActivitys = ({}) => {
  const [data, setPageNumber, deleteBtnClicked, reloadData, setReloadData] =
    useAllActivitys();

  const searchParams = new URLSearchParams(window.location.search);

  const paramsLimit = searchParams?.get('limit') || LIMIT;

  const { data: activityData } = useActivities();

  // const {data:xyz}=useQuery({})

  console.log(data, 'Activity Data');

  const [updateData] = useUpdateActivity();

  const {
    activitys_loading,
    activitys,
    total_activitys,
    page,
    pages,
    statusCounts,
  } = data;

  const [comment_data, setActivity, setReloadComments] = useAllComments();
  const { comments, comments_loading } = comment_data;
  const [commentData, addData] = useCreateComment();
  const submitFormClicked = async (values) => {
    await addData(values);
    setReloadComments(true);
  };

  const [
    dropdownOptions,
    setEmployeeSearchField,
    setEmployeeSearchValue,
    setClientSearchField,
    setClientSearchValue,
    setProcessSearchField,
    setProcessSearchValue,
    setActivitystatusSearchField,
    setActivitystatusSearchValue,
    setReviewstatusSearchField,
    setReviewstatusSearchValue,
    setActivitycycleSearchField,
    setActivitycycleSearchValue,
  ] = useGetDropdownOptions();

  const loadOptions = async (inputValue, callback, field) => {
    if (field == 'assigned_to') {
      setEmployeeSearchField('name');
      setEmployeeSearchValue(inputValue);
      callback(dropdownOptions.assigned_to);
    }
    if (field == 'client') {
      setClientSearchField('name');
      setClientSearchValue(inputValue);
      callback(dropdownOptions.client);
    }
    if (field == 'process') {
      setProcessSearchField('name');
      setProcessSearchValue(inputValue);
      callback(dropdownOptions.process);
    }
    if (field == 'activity_status') {
      setActivitystatusSearchField('name');
      setActivitystatusSearchValue(inputValue);
      callback(dropdownOptions.activity_status);
    }
    if (field == 'review_status') {
      setReviewstatusSearchField('name');
      setReviewstatusSearchValue(inputValue);
      callback(dropdownOptions.review_status);
    }
    if (field == 'activity_cycle') {
      setActivitycycleSearchField('name');
      setActivitycycleSearchValue(inputValue);
      callback(dropdownOptions.activity_cycle);
    }
  };

  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [editId, setEditId] = useState(null);

  const [loadingActivityStatus, setLoadingActivityStatus] = useState(false);

  const updateStatus = async (id, status) => {
    // console.log("ID", id, value);
    if (id && status) {
      setLoadingActivityStatus(true);
      // const newForm = new FormData();
      // newForm.append('values', JSON.stringify(status));
      await updateData(id, status);
      await setReloadData(true);
      setEditId(null);
      setLoadingActivityStatus(false);
    } else {
      setEditId(null);
    }
  };

  const [exportXLSXData] = UseFilter();

  const [convertToReadable, exportData] = UseDataForExcel();

  useEffect(() => {
    if (activitys) {
      convertToReadable(activitys, inputFields);
    }
  }, [activitys]);

  const handleOnExport = () => {
    exportXLSXData(exportData, 'Activities', 'activities');
  };

  const userData = useSelector((state) => state.auth);
  const { user } = userData;

  const [total_estimated_time, setTotal_estimated_time] = useState(0);
  const [total_actual_time, setTotal_actual_time] = useState(0);

  useEffect(() => {
    if (activitys) {
      let total_activity_time = 0;
      let total_actual_time = 0;
      activitys.map((item) => {
        if (item.estimated_time) {
          total_activity_time =
            total_activity_time +
            Number(item.estimated_time ? item.estimated_time : 0);
          total_actual_time =
            total_actual_time + Number(item.actual_time ? item.actual_time : 0);
        }
      });
      setTotal_estimated_time(total_activity_time);
      setTotal_actual_time(total_actual_time);
    }
  }, [activitys]);

  const [showChecklist, setShowChecklist] = useState(false);
  const [checklistData, setChecklistData] = useState(null);

  const handleChecklist = (data) => {
    setChecklistData(data);
    setShowChecklist(true);
  };

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_TITLE}
          mainLinkTitle='Dashboard'
          mainLinkUrl='/dashboard'
          activeLink={PAGE_TITLE}
        />
        <ExportComponent handleOnExport={handleOnExport} />
        <FilterDateComponent
          link='/activitys'
          showOwn={true}
          searchParams={{ term: 'assigned_to', value: user._id }}
          searchField='due_time'
        />

        <EnhancedTableSection
          SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
          dropdownOptions={dropdownOptions}
          loadOptions={loadOptions}
          total_estimated_time={total_estimated_time}
          total_actual_time={total_actual_time}
          total_activitys={total_activitys}
          activitys_loading={activitys_loading}
          activitys={activitys}
          page={page}
          pages={pages}
          setPageNumber={setPageNumber}
          LIMIT={paramsLimit}
          updateStatus={updateStatus}
          deleteBtnClicked={deleteBtnClicked}
          setModal={setModal}
          setModalData={setModalData}
          setActivity={setActivity}
          handleChecklist={handleChecklist}
          loadingActivityStatus={loadingActivityStatus}
          AddBtn={AddBtn}
          QuickAddBtn={QuickAddBtn}
          statusCounts={statusCounts}
        />
      </div>
      <ReactModal
        isOpen={modal}
        contentLabel='Modal'
        className='Modal'
        overlayClassName='Overlay'
        onRequestClose={() => {
          setModal(false);
        }}
      >
        <div className='quick-view'>
          <div className='qv-header'>
            <div className='title'> {PAGE_SINGLE_TITLE} </div>
            <div>
              <button
                onClick={() => {
                  setModal(false);
                }}
                className='btn btn-primary'
              >
                <i className='fa fa-times'></i>
              </button>
            </div>
          </div>
          {modalData && (
            <>
              <div className='qv-body'>
                <SingleView
                  hideGallery={true}
                  data={modalData}
                  inputFields={inputFields}
                  label={PAGE_SINGLE_TITLE}
                  link={LINK_URL}
                  id={modalData._id}
                  hideAllBtn={false}
                  col={12}
                />
                <div className='card'>
                  <div className='card-body'>
                    <Formik
                      initialValues={{
                        comment: '',
                      }}
                      validationSchema={Yup.object({
                        comment: Yup.string().required('Required'),
                      })}
                      onSubmit={async (
                        values,
                        { setSubmitting, resetForm }
                      ) => {
                        setSubmitting(true);
                        values.activity = modalData._id;
                        await submitFormClicked(values);
                        resetForm();
                        setSubmitting(false);
                      }}
                    >
                      {(formik) => {
                        // console.log(formik);
                        return (
                          <Form>
                            <div className='row align-items-center'>
                              <div className='col-md-9'>
                                <TextArea
                                  label='Comment'
                                  name='comment'
                                  type='text'
                                />
                              </div>
                              <div className='col-md-3'>
                                <button
                                  type='submit'
                                  className='btn btn-success'
                                >
                                  {' '}
                                  {formik.isSubmitting
                                    ? 'SAVING...'
                                    : 'SAVE'}{' '}
                                </button>
                              </div>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
                <div className='card'>
                  <div className='card-body'>
                    <table className='table table-stripped'>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Comment</th>
                          <th>Comment By</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!comments_loading ? (
                          <>
                            {comments &&
                              comments.map((item, index) => {
                                return (
                                  <tr>
                                    <td> {index + 1} </td>
                                    <td> {item.comment} </td>
                                    <td>
                                      {' '}
                                      {item.created_by &&
                                        item.created_by.name}{' '}
                                    </td>
                                    <td>
                                      {' '}
                                      {item.createdAt &&
                                        moment(item.createdAt).format(
                                          'DD-MM-YYYY hh:mm A'
                                        )}{' '}
                                    </td>
                                  </tr>
                                );
                              })}
                          </>
                        ) : (
                          <>
                            <p> Loading... </p>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </ReactModal>
      {/* checklistData, setChecklistData */}
      <ChecklistModal
        modal={showChecklist}
        setModal={setShowChecklist}
        activity={checklistData}
        setActivity={setChecklistData}
        updateStatus={updateStatus}
      />
    </div>
  );
};

export default AllActivitys;
